import { Card } from 'antd';

export default function Dashboard() {
	return (
		<Card title="欢迎使用 Be-Link 管理后台">
			<p>
				这是一个基于 React 19 + TypeScript + Rsbuild + Ant Design
				构建的现代化管理后台系统。
			</p>
			<ul>
				<li>✨ 使用最新的 React 19 和 TypeScript 5</li>
				<li>⚡️ 基于 Rsbuild 的快速构建体验</li>
				<li>🎨 Ant Design 6.x 组件库</li>
				<li>🔐 完整的权限管理和路由守卫</li>
				<li>📦 Zustand 状态管理</li>
			</ul>
		</Card>
	);
}
